export default function() {
    const anchors = document.querySelectorAll('a');
    const anchorsLength = anchors.length;
    if (anchorsLength == 0) {
        return;
    }
    for (let index = 0; index < anchorsLength; index++) {
        const anchor = anchors[index];
        try {
            anchor.addEventListener('click', function() {
                if (this.pathname == window.location.pathname && this.protocol == window.location.protocol && this.host == window.location.host && window.headroom) {
                    window.headroom.unpin();
                    // window.headroom.freeze();
                }
            })
        }
        catch (e) {
            console.error(e);
        }
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/fleet-and-business/modules/anchor-fix.js